import creatorsLandingData from "./creatorsLanding.json";
import type { SupportedLanguage } from "../locales";
import { getCreatorsArticleContent } from "./creatorsArticle";

type CreatorsLandingEntry = {
  label: string;
  slug: string;
};

const creatorsLandingConfig = creatorsLandingData as Record<SupportedLanguage, CreatorsLandingEntry>;

export const CREATORS_LANDING_PATH = `/${creatorsLandingConfig.en.slug}` as const;

export const CREATORS_LANDING_PATHS_BY_LANGUAGE = Object.fromEntries(
  Object.entries(creatorsLandingConfig).map(([language, entry]) => [
    language,
    language === "en" ? `/${entry.slug}` : `/${language}/${entry.slug}`,
  ]),
) as Record<SupportedLanguage, string>;

export function getCreatorsLandingLabel(language: SupportedLanguage): string {
  return creatorsLandingConfig[language]?.label || creatorsLandingConfig.en.label;
}

export function getCreatorsLandingPath(language: SupportedLanguage): string {
  return CREATORS_LANDING_PATHS_BY_LANGUAGE[language] || CREATORS_LANDING_PATHS_BY_LANGUAGE.en;
}

export function getCreatorsLandingSeo(language: SupportedLanguage) {
  const article = getCreatorsArticleContent(language);
  return {
    title: article.seoTitle,
    description: article.seoDescription,
  };
}
